/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLayout1Col2Row = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 22V2h20v20zm9-18H4v16h7zm9 9h-7v7h7zm0-9h-7v7h7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLayout1Col2Row as Layout1Col2Row };
